<template>
  <div class="fee">
    {{ $t('message.fee_notice', {token, fee}) }}
    <div class="note">
      {{ $t('message.fee_subject_to_change') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'feeNotice',
  props: {
    token: {
      type: String,
      default: ''
    },
    fee: {
      type: Number,
      default: 0
    }
  }
}

</script>

<style scoped>
  .fee {
    margin-top: 30px;
    border: 1px solid orangered;
    border-left: 6px solid red;
    border-radius: 4px;
    padding: 12px;
    font-weight: 500;
  }
  .note {
    font-weight: 300;
    margin-top: 10px;
    color: grey;
  }
</style>
